import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PropertyCharacteristicsDto, PropertyPhotoDto } from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../../../pipes/etxe-enum-display.pipe';

@Component({
  selector: 'etxe-photo-gallery',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatTooltipModule,
    EtxeEnumDisplayPipe,
  ],
  templateUrl: './photo-gallery.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhotoGalleryComponent {
  photos = input.required<PropertyPhotoDto[]>();
  propertyCharacteristics = input<PropertyCharacteristicsDto>();

  addClicked = output<void>();
  manageClicked = output<void>();
}
